import {ifCanPushDatalayer} from './utils/utils.dataLayer.common';

//UCS003
const dataLayerContentSharing = () => {
	ifCanPushDatalayer({
		then: () => {
			const sharingButton = document.querySelectorAll('[data-layer="content-sharing"] a');

			sharingButton.forEach((el) => {
				const socialNetwork = el.dataset.title;

				el.addEventListener('click', (button) => {
					dataLayerBus.push({
						"event": "user_interaction",
						"event_name": "share",
						"interaction": {
							"social_network": socialNetwork
						}
					});
				});
			});
		}
	});
};

export default dataLayerContentSharing;